export default {
  root: {},
  input: {
    '& input[type="color"]': {
      top: 6
    }
  },
  gradientInput: {
    height: 20,
    width: '100%',
    marginBottom: 40,
    position: 'relative',
    '& > input': {
      position: 'absolute',
      pointerEvents: 'none',
      zIndex: 2,
      height: 20,
      width: 'calc(100% + 26px)',
      opacity: 0,
      top: 0,
      left: -26,
      margin: 0,
      appearance: 'none',
      '&::-webkit-slider-thumb': {
        pointerEvents: 'all',
        width: 27,
        height: 25,
        borderRadius: 0,
        border: '0 none',
        backgroundColor: 'blue',
        appearance: 'none',
        top: 28,
        position: 'relative',
        padding: 13,
        cursor: 'pointer'
      }
    },
    '& > input[name="percentage1"]': {
      left: -13
    },
    '& > input[name="percentage2"]::-webkit-slider-thumb': {
      transform: 'translateX(50%)'
    }
  },
  gradientHandle: {
    position: 'absolute',
    left: 0,
    top: 20,
    transform: 'translateX(-50%)',
    '&.active $arrow, &.active $colorPickerWrap': {
      borderColor: '#0070b9'
    }
  },
  arrow: {
    transform: 'rotate(45deg)',
    borderTopWidth: 1,
    borderLeftWidth: 1,
    background: '#fff',
    height: 5,
    width: 5,
    border: '0 solid #c8c8c8',
    position: 'absolute',
    left: 'calc(50% - 2.5px)',
    top: 2
  },
  colorPickerWrap: {
    padding: 2,
    lineHeight: '10px',
    background: '#fff',
    border: '1px solid #c8c8c8',
    borderRadius: 4,
    marginTop: 5
  },
  colorIndicator: {
    height: 21,
    width: 21,
    padding: 0,
    border: 0
  },
  colorInput: {
    '&.active label input': {
      borderColor: '#0070b9'
    }
  },
  angleWrap: {
    position: 'relative',
    marginBottom: 20
  },
  angleHandle: {
    position: 'relative',
    top: 0,
    left: 0,
    display: 'inline',
    '& input': {
      appearance: 'none',
      border: 0,
      width: 26,
      textAlign: 'right'
    }
  },
  angleSlider: {
    height: 3,
    margin: 0,
    width: '100%',
    appearance: 'none',
    '&::-webkit-slider-thumb': {
      background: '#4c4c4c',
      height: 15,
      width: 15,
      borderRadius: '50%',
      appearance: 'none',
      cursor: 'pointer'
    }
  }
};
